import React from 'react';
import { useParams } from "react-router-dom";
import BookJumperContainer from '../components/BookJumperContainer/BookJumperContainer';

function EditResult(props) {
    const { competition_id, id } = useParams();

    return (
        <BookJumperContainer typeBooksResults="results" competition_id={competition_id} id={id}/>
    );
}

export default EditResult;